// extracted by mini-css-extract-plugin
export var alertIcon = "_so-0";